module.exports = __webpack_public_path__ + "img/bootstrap-vue.82ecc074.png";